const datatableStyles = {
    header: {
        style: {
				backgroundColor: "#D0D0CF",
				
            color: "#212F41",
        }
    },
    subHeader: {
        style: {
            backgroundColor: "#D0D0CF",
            color: "#212F41",
        }
    },
    headRow: {
        style: {
				backgroundColor: "#D0D0CF",
				borderBottom: "#D0D0CF !important",
        }
    },
    headCells: {
        style: {
            color: "#212F41",
        }
    }
}

export default datatableStyles;